<template>
    <div class="mt-3">
        <div class="data-container">
            <b-table :items="list"
                :fields="fields"
                :current-page="page"
                ref="ChannelMatrixList"
                responsive
                show-empty
                :empty-text="(loading) ? 'Loading data' : 'No Data Available'">
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ChannelMatrixTable",
    data() {
        return {
            fields: [
                { key: "sales_organization", sortable: true },
                { key: "account_group", sortable: true },
                { key: "customer_hierarchy_type", sortable: true },
                { key: "level1", sortable: true },
                { key: "level1_description", sortable: true },
                { key: "level2", sortable: true },
                { key: "level2_description", sortable: true },
                { key: "level3", sortable: true },
                { key: "level3_description", sortable: true },
                { key: "level4", sortable: true },
                { key: "level4_description", sortable: true },
                { key: "level5", sortable: true },
                { key: "level5_description", sortable: true },
                { key: "major_channel_phic", label: "Major Channel PH IC", sortable: true }
            ],
            page: 1
        };
    },
    computed: {
        ...mapState("reportsChannel", [
            "loading",
            "list",
            "param"
        ])
    },
    created: async function() {
        let param = await {
            keyword: null,
            filter: null
        };
        let limit = this.$moment(new Date()).format("M");
        let page = 1;
        await this.$store.commit("reportsChannel/setParam", {
            param,
            page
        });
        await this.getList();
    },
    methods: {
        getList: async function() {
            await this.$store.dispatch("reportsChannel/getList", this.param);
        }
    }
}
</script>
